<template>
  <div style="overflow-x: scroll" class="perlschnur-container pt-3 no-overscroll">
    <div class="d-flex" v-if="enableUmlaufSelection && umlaeufeWithFahrten > 1">
      <div class="mr-2 mt-1">Wagenumläufe</div>
      <v-btn
        rounded
        small
        :color="umlauf === umlaufObj.umlauf ? 'grey lighten-1' : ''"
        :outlined="umlauf !== umlaufObj.umlauf"
        class="mr-2 mb-2"
        v-for="(umlaufObj, ind) in umlaeufe"
        :key="ind"
        @click="selectUmlauf(umlaufObj)"
        >Kurs {{ umlaufObj.kurs }}, Abfahrt {{ umlaufObj.abfahrt }}Uhr, ab
        {{ umlaufObj.abOrt }}
      </v-btn>
    </div>
    <!-- an additional header configured in ui-config module config and sourced by perlschnurJson header data -->
    <div v-if="perlschnurHeader && perlschnurHeaderData" class="px-4 pb-2 mb-2 d-flex align-center justify-start" style="border-bottom: 1px solid #d0d0d0">
      <div v-for="col in perlschnurHeader" :key="col.key" class="d-flex pr-7">
        <!--        <span v-if="col.key === 'SELECTION'">-->
        <!--          <b>{{ $t(col.titleKey) }}: </b>{{ track || line }}-->
        <!--        </span>-->
        <!--        <span-->
        <b> {{ col.titleKey }}:&nbsp;</b>{{ perlschnurHeaderData[col.key] }}
        <!--        </span>-->
      </div>
      <div class="d-flex">
        <v-btn v-if="!$route.name.includes('fahrdienst452')" icon @click="headToFahrdienst452">
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>
    <horizontal-perlschnur-verlauf-times
      v-if="showHorizontalTimeline"
      :rows="rows"
      @scrollToItemWithId="scrollToItemWithId"
      :selectedRowIndex="0"
      :dateString="dateString"
    ></horizontal-perlschnur-verlauf-times>

    <div v-if="!rows || rows.length === 0" class="pa-5 d-flex justify-center align-center">{{ $t('fd.noDataTitle') }}</div>
    <virtual-scroll-list
      v-else
      class="no-overscroll scroll-container"
      ref="vscroller"
      :items="rows"
      :scrollAreaPixelHeight="scrollAreaPixelHeight"
      :defaultItemPixelHeight="xs ? 65 : 43"
      itemIdAttribute="rowId"
      itemPixelHeightAttribute="height"
    >
      <template v-slot:header>
        <verlauf-header :perlschnurColumns="perlschnurColumns" :perlschnurColumnsXs="perlschnurColumnsXs" class="px-0 px-sm-1 mt-0 mt-xl-2"></verlauf-header>
      </template>

      <template v-slot:item="{ item }">
        <div>
          <verlauf-header
            v-if="item.start && false"
            :perlschnurColumns="perlschnurColumns"
            :perlschnurColumnsXs="perlschnurColumnsXs"
            class="px-0 px-sm-1 mt-5"
          ></verlauf-header>
          <v-divider v-if="item.start" class="mb-2"></v-divider>
          <verlauf
            v-if="!xs"
            @click="highlightRow(item.rowId)"
            :item="item"
            :perlschnurColumns="perlschnurColumns"
            :isLastItem="item.index === rows.length - 1"
            :isHighlighted="item.rowId === highlightedRowId"
            :themeName="themeName"
            :configuredTimeFormat="configuredTimeFormat"
            :key="item.rowId"
            :displayJsonPopUp="false"
            :dateString="dateString"
          ></verlauf>
          <Verlauf_xs
            v-else
            @click="highlightRow(item.rowId)"
            :item="item"
            :perlschnurColumnsXs="perlschnurColumnsXs"
            :isLastItem="item.index === rows.length - 1"
            :isHighlighted="item.rowId === highlightedRowId"
            :themeName="themeName"
            :configuredTimeFormat="configuredTimeFormat"
            :key="item.rowId"
            :dateString="dateString"
          ></Verlauf_xs>
        </div>
      </template>
    </virtual-scroll-list>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import Verlauf from '@/modules/common/Verlauf';
import Verlauf_xs from '@/modules/common/Verlauf_xs';
import VerlaufHeader from '@/modules/common/VerlaufHeader';
import PerlschnurBuilder from '@/modules/common/PerlschnurBuilder.js';
import PerlschnurJsonBuilder from '@/modules/common/PerlschnurJsonBuilder.js';
import VirtualScrollList from '@/components/container/VirtualScrollList.vue';
import HorizontalPerlschnurVerlaufTimes from './HorizontalPerlschnurVerlaufTimes.vue';
import nonReactiveFahrdienst452Store from '../fahrdienst452/storeNonReactive';
import dateUtils from '@/common/dateUtils';

let builder;
let interval;
let timeout;
const debug = false;

export default {
  name: 'Perlschnur',
  mixins: [commonMixin, configMixin],

  components: { Verlauf, Verlauf_xs, VerlaufHeader, VirtualScrollList, HorizontalPerlschnurVerlaufTimes },

  props: {
    tenant: String,

    perlschnurHeader: Array,
    perlschnurColumns: Array,
    perlschnurColumnsXs: Array,

    scrollAreaPixelHeight: { type: Number, default: 500 },
    startToMinutesAfterMidnight: { type: Number, required: false },
    endToMinutesAfterMidnight: { type: Number, required: false },
    line: { type: String, required: false }, // define either line or track
    track: { type: String, required: false }, // track=Kurs
    tourHashParam: { type: String, required: false },
    blockcode: { type: String, required: false }, // track=Kurs
    dateIsoString: { type: String },
    dateString: { type: String },
    initiallyScrollToCurrentTime: { type: Boolean, default: true }, // set true to initially scroll to current time
    autoScrollToCurrentTime: { type: Boolean, default: false }, // set to true to automatically scroll to current time (checked every minute)
    showHorizontalTimeline: { type: Boolean, default: true },
    enableUmlaufSelection: { type: Boolean, default: true }, // if multiple Umläufe are given, this property defines if the user may select the umlauf or if it is determined from the givcen kurs
  },

  data() {
    return {
      USE_PERLSCHNUR_JSON: true,
      rows: null, // Perlschnur data prepared by PerlschnurBuilder (render-ready)
      highlightedRowId: null, // rowId of the highlighted row
      perlschnurHeaderData: null, // optional header information from perlschnur data
      umlaeufe: [],
      umlauf: null,
      fahrtenAndUmlaufList: [],
      umlaeufeWithFahrten: null,
    };
  },
  mounted() {
    console.debug('Perlschnur.vue mounted. Build perlschnur from', this.tourHashParam);
    console.debug('perlschnurColumns', this.perlschnurColumns);
    // this.build();
  },
  beforeDestroy() {
    // debug && console.debug('Clear timer interval');
    if (interval) clearInterval(interval);
  },

  methods: {
    headToFahrdienst452() {
      let dateYYYYMMDD = dateUtils.formatDateAsYYYYMMDD(dateUtils.parseISOString(this.dateIsoString));

      this.$router.push(`/fahrdienst452/tour/${dateYYYYMMDD}/${this.line}/${this.track}`);
    },
    stopAutoScrollingToCurrentTime() {
      debug && console.debug('stopAutoScrollingToCurrentTime');
      if (interval) clearInterval(interval);
      if (timeout) clearTimeout(timeout);
      this.removeHighlight();
      if (this.rows && this.rows.length > 0) this.scrollToItemWithId(this.rows[0].rowId);
    },
    startAutoScrollingToCurrentTime() {
      let now = new Date();
      let msFromNow = (60 - now.getSeconds()) * 1000;
      debug && console.debug('startAutoScrollingToCurrentTime start in ', msFromNow, 'ms');

      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (interval) clearInterval(interval);

        debug && console.debug('start interval (1 Min)');
        interval = setInterval(() => {
          this.highlightCurrentRow();
        }, 1000 * 60);

        this.highlightCurrentRow();
      }, msFromNow);
      setTimeout(() => this.highlightCurrentRow(), 500);
    },
    scrollToItemWithId(rowId) {
      if (this.$refs['vscroller'] && rowId) {
        this.highlightedRowId = rowId;
        this.$refs['vscroller'].scrollToRowWithItemId(rowId);
      }
    },
    async build() {
      this.initBuilder();
      let { tourHashParam, line, track, selectedUmlauf, startToMinutesAfterMidnight, endToMinutesAfterMidnight, dateIsoString } = this;

      debug &&
        console.debug(`Perlschnur build {line, track,umlauf=${this.umlauf} startToMinutesAfterMidnight, endToMinutesAfterMidnight, dateIsoString}`, {
          line,
          track,
          startToMinutesAfterMidnight,
          endToMinutesAfterMidnight,
          dateIsoString,
        });
      if ((tourHashParam || line || track) && dateIsoString) {
        let { header, umlaeufe, umlauf, fahrtenAndUmlaufList, selectedUmlaufIndex, umlaeufeWithFahrten } = await builder.calculateItems({
          startToMinutesAfterMidnight,
          endToMinutesAfterMidnight,
          line,
          track,
          umlauf: this.umlauf,
          blockcode: this.blockcode,
          tourHashParam: this.tourHashParam,
          dateIsoString,
          autoSelectUmlauf: !this.enableUmlaufSelection,
        });
        // console.debug('calculated perlschnur umlaeufe', umlaeufe, 'umlauf', umlauf, 'selectedUmlaufIndex', selectedUmlaufIndex, 'umlaeufeWithFahrten', umlaeufeWithFahrten, 'fahrtenAndUmlaufList', fahrtenAndUmlaufList)
        if (!fahrtenAndUmlaufList || fahrtenAndUmlaufList.length === 0) {
          console.warn('currently no perlschnur data available');
          this.rows = [];
          return;
        }
        this.perlschnurHeaderData = header;
        this.umlaeufeWithFahrten = umlaeufeWithFahrten;
        this.fahrtenAndUmlaufList = fahrtenAndUmlaufList;

        if (this.umlauf !== umlauf) {
          console.debug('received different umlauf than requested. Switch umlauf selector from ', this.umlauf, 'to', umlauf);
          this.umlauf = umlauf;
        }

        this.umlaeufe = umlaeufe;
        let selectedUmlauf = fahrtenAndUmlaufList[selectedUmlaufIndex];

        let rows = selectedUmlauf.fahrten;

        if (this.tenant === 'lvb') {
          if (rows && rows.length > 1) {
            let rowsLen = rows.length;
            let prevRow = rows[rowsLen - 2];
            let lastRow = rows[rowsLen - 1];
            if (lastRow?.location === 'Thekla (Steig E)') {
              if (prevRow?.ab === lastRow?.ab) {
                rows.pop();
                console.debug('Thekla (Steig E) removed', lastRow);
              }
            }
          }
        }
        // if (rows && rows.length > 0) this.highlightedRowId = rows[0].rowId;
        this.$emit('onIncludedTracksChanged', selectedUmlauf.includedTracks);
        this.rows = rows;
        this.$nextTick(() => {
          if (this.autoScrollToCurrentTime) {
            this.startAutoScrollingToCurrentTime();
          }

          if (this.initiallyScrollToCurrentTime && !this.autoScrollToCurrentTime) {
            this.highlightCurrentRow();
          }
        });
      } else {
        console.debug('missing required data');
        this.rows = [];
      }
    },
    selectUmlauf(umlaufObj) {
      this.umlauf = umlaufObj.umlauf;
      console.debug('selectUmlauf and initiate perlschnur build', this.umlauf);
      this.build();
    },
    removeHighlight() {
      this.highlightedRowId = null;
    },
    highlightRow(rowId) {
      // debug && console.debug('highlightRow', rowId);
      this.highlightedRowId = rowId;
    },
    highlightCurrentRow() {
      let currentRow = this.findCurrentRow();
      if (currentRow) {
        this.highlightRow(currentRow.rowId);
        this.scrollToItemWithId(currentRow.rowId);
      }
    },
    /**
     * Finds the current time slot whereby the minutesAfterMidnight is after or equal the start time and lower than the start of the next track.
     *
     * @returns null if no slot has been found, otherwise an object with minutesAfterMidnight and index property is returned. The index is the index of the found slot in stopAndStartTimeList
     */
    findCurrentRow() {
      let now = new Date();
      let minutesAfterMidnight = now.getMinutes() + now.getHours() * 60;
      // debug && console.debug('findCurrentRow for minutesAfterMidgnight', minutesAfterMidnight);
      if (this.rows) {
        let rowIndex = this.rows.findIndex((f) => {
          if (f.an && f.ab) return f.ab > minutesAfterMidnight;
          if (f.an) return f.an > minutesAfterMidnight;
          if (f.ab) return f.ab > minutesAfterMidnight;
          return false;
        });
        if (rowIndex >= 0) {
          return this.rows[rowIndex === 0 ? 0 : rowIndex - 1];
        }
      }
      return null;
    },

    initBuilder() {
      if (this.USE_PERLSCHNUR_JSON) {
        console.debug('We use perlschnur from json file');
        builder = new PerlschnurJsonBuilder({
          tenant: this.tenant,
          timetable: nonReactiveFahrdienst452Store.timetable,
          perlschnurJsonByTourHash: nonReactiveFahrdienst452Store.perlschnurJsonByTourHash,
        });
      } else {
        let {
          //fahrtBy_day_kurs,
          verlaufByAdapterLinieId,
          bemerkungIdBy_fahrtId_startOrtIdFk,
          bemerkungById,
          bemerkungIdBy_fahrtId_endOrtIdFk,
        } = this.$store.state.fahrdienst452;
        builder = new PerlschnurBuilder({
          tenant: this.tenant,
          //fahrtBy_day_kurs,
          verlaufByAdapterLinieId,
          bemerkungIdBy_fahrtId_startOrtIdFk,
          bemerkungById,
          bemerkungIdBy_fahrtId_endOrtIdFk,
        });
      }
    },
  },

  watch: {
    //watches all changes on all props
    $props: {
      handler(newValue, oldValue) {
        if (!newValue || !oldValue) {
          console.debug('properties object is null. Perlschnur Build perlschnur', newValue, oldValue);
          this.build();
          return;
        }
        if (newValue.startToMinutesAfterMidnight !== oldValue.startToMinutesAfterMidnight) {
          console.debug('startToMinutesAfterMidnight changed old=', oldValue.startToMinutesAfterMidnight, 'newValue', newValue.startToMinutesAfterMidnight);
        }
        if (newValue.endToMinutesAfterMidnight !== oldValue.endToMinutesAfterMidnight) {
          console.debug('endToMinutesAfterMidnight changed old=', oldValue.endToMinutesAfterMidnight, 'newValue', newValue.endToMinutesAfterMidnight);
        }
        if (newValue.track !== oldValue.track) {
          console.debug('track changed old=', oldValue.track, 'newValue', newValue.track);
        }
        if (newValue.dateIsoString !== oldValue.dateIsoString) {
          console.debug('dateIsoString changed old=', oldValue.dateIsoString, 'newValue', newValue.dateIsoString);
        }
        if (newValue.tourHashParam !== oldValue.tourHashParam) {
          console.debug('tourHashParam changed old=', oldValue.tourHashParam, 'newValue', newValue.dateIsoString);
        }
        console.debug('build Perlschnur because properties above changed');
        this.umlauf = null;
        this.build();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
